import { IconButton, Typography } from 'seagull';
import { AccountingMappingIcon } from 'seagull/icons';
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { Accounting } from "../../../../../types/api.model";
import styles from "../ServicesSection.module.scss";
import { getAccountingTooltip } from "./ServiceBillingItem.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ServiceTitle(_ref) {
  let {
    name,
    serviceId,
    qboItemName,
    xeroItemName,
    qboClassName,
    noWrap
  } = _ref;
  const {
    XERO_INTEGRATION
  } = useFeatureFlags();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.serviceName,
    children: [/*#__PURE__*/_jsx(Typography, {
      noWrap: noWrap,
      testId: "name",
      children: name
    }), qboItemName && /*#__PURE__*/_jsx(IconButton, {
      tooltip: {
        placement: 'top',
        title: getAccountingTooltip({
          accounting: Accounting.QBO,
          itemName: qboItemName,
          className: qboClassName
        })
      },
      noPadding: true,
      size: "small",
      skin: "primaryTransparent",
      testId: "maunal-service-qbo-synced-".concat(serviceId),
      cursorDefault: true,
      children: /*#__PURE__*/_jsx(AccountingMappingIcon, {
        size: 18,
        testId: "qbo-map-icon-".concat(serviceId)
      })
    }), xeroItemName && XERO_INTEGRATION && /*#__PURE__*/_jsx(IconButton, {
      tooltip: {
        placement: 'top',
        title: getAccountingTooltip({
          accounting: Accounting.Xero,
          itemName: xeroItemName
        })
      },
      noPadding: true,
      size: "small",
      skin: "primaryTransparent",
      testId: "maunal-service-xero-synced-".concat(serviceId),
      cursorDefault: true,
      children: /*#__PURE__*/_jsx(AccountingMappingIcon, {
        size: 18,
        testId: "xero-map-icon-".concat(serviceId)
      })
    })]
  });
}